import React, { useEffect } from "react";
import "./OverallScoreTooltip.css";

/**
 * Componente reutilizável do tooltip de "Nota Geral"
 *
 * @param {Object} props
 * @param {boolean} props.visible - controla exibição do tooltip
 * @param {string} props.purposeLabel - label do propósito ("Gamer", "Uso geral", etc)
 * @param {Object} props.weights - objeto com { "Processador": 0.25, "Tela": 0.15, ... }
 * @param {Function} props.onClose - callback para fechar tooltip ao clicar fora
 */
function OverallScoreTooltip({ visible, purposeLabel, weights = {}, onClose }) {
  // fecha ao clicar fora
  useEffect(() => {
    if (!visible) return;
    const handleClickOutside = (e) => {
      if (
        !e.target.closest(".overall-tooltip") &&
        !e.target.closest(".tooltip-trigger")
      ) {
        onClose?.();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [visible, onClose]);

  if (!visible || !purposeLabel) return null;

  return (
    <div className="overall-tooltip">
      <div className="tooltip-header">
        <strong>Nota geral</strong>
        <p>
          É uma <span className="highlight">média ponderada</span> das notas dos
          componentes.
        </p>
      </div>

      <div className="tooltip-purpose">
        <span className="purpose-label">Propósito:</span>{" "}
        <span className="purpose-value">{purposeLabel}</span>
      </div>

      <ul className="tooltip-weights">
        {Object.entries(weights).map(([componentLabel, weight]) => (
          <li key={componentLabel}>
            <span className="component-name">{componentLabel}</span>
            <span className="component-weight">
              {(weight * 100).toFixed(0)}%
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default OverallScoreTooltip;
